<template>
  <NavBar/>

  <div class="about min-vh-100 mx-auto pt-5">
      <div class="hero text-center">
          <h2>About Us</h2>
          <p>We are a company of IT students.
               We offer an archive of free projects
               that you may like. We also have games
               check it out.
          </p>
      </div>
  </div>
  
  <Footer/>
</template>

<script>
import NavBar from '../components/NavBar.vue'
import Footer from '../components/Footer.vue'

export default {
  components: {
    NavBar,
    Footer
  },
  setup(){
    document.title = 'Soncraft - About'
  }
}
</script>

<style>

@media screen and (max-width: 900px){
  .hero h2{
      font-size: 350%;
  }
  .hero p{
      font-size: 1rem;
      padding-left: 10%;
      padding-right: 10%;
  }
  .features .heading h2{
      font-size: 175%;
  }
  .features .row{
      font-size: 100%;
  }
  .features .project{
      width: 20rem;
  }
  .projects .heading h2{
      font-size: 175%;
  }
  .projects .row{
      width: 100%;
  }
  .projects .category-container{
      width: 8.5rem;
      height: 9.5rem;
  }
  .projects .category{
    width: 8rem;
    height: 9.5rem;
  }
  .projects .category .card-title{
    font-size: 1.2rem;
  }
}
</style>
